import { Card } from "@mui/material";

import CardHeader from "./CardHeader";
import Context from "./context";
import CrateSecretDialog from "./CrateSecretDialog/CrateSecretDialog";
import RevokeSecretDialog from "./RevokeSecretDialog/RevokeSecretDialog";
import useSecretsCardActionsStore from "./store";
import SecretsTable from "./Table/SecretsTable";

// ----------------------------------------------------------------------

export const SecretsCard = () => {
	const [state, actions] = useSecretsCardActionsStore();

	return (
		<Context.Provider value={{ actions, state }}>
			<Card sx={{ maxWidth: 1100, pb: 3 }}>
				<CardHeader />
				<SecretsTable />
			</Card>
			<CrateSecretDialog
				onClose={actions.hideCheckPassCreatetDialog}
				show={state.showCheckPassCreatetDialog}
			/>
			<RevokeSecretDialog
				onClose={actions.hideCheckPassRevokeDialog}
				show={state.showCheckPassRevokeDialog}
			/>
		</Context.Provider>
	);
};

export default SecretsCard;
